function normalizeEventTypes(value) {
  const values = Array.isArray(value) ? value : typeof value === "string" ? value.split(",") : [];
  return [...new Set(values.map((item) => String(item).trim()).filter(Boolean))];
}

export function getArtistEventTypes(profile, about) {
  const answers = [...(about?.universal || []), ...(about?.category || [])];
  const questionnaireAnswer = answers.find((answer) => answer.id === "event_types");

  if (questionnaireAnswer) return normalizeEventTypes(questionnaireAnswer.answer);
  return normalizeEventTypes(profile?.event_types);
}
